import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getTaskStatuses({ uuid }) {
      const res = getState().find(({ project }) => project.uuid === uuid);

      return res ? res.statuses : [];
    },
    isTaskStatusesRetrievalRequestFailure({ uuid }) {
      const res = getState().find(({ project }) => project.uuid === uuid);

      return res ? res.request.isFailure : false;
    },
    isTaskStatusesRetrievalRequestPending({ uuid }) {
      const res = getState().find(({ project }) => project.uuid === uuid);

      return res ? res.request.isPending : false;
    },
    isTaskStatusesRetrievalRequestSuccess({ uuid }) {
      const res = getState().find(({ project }) => project.uuid === uuid);

      return res ? res.request.isSuccessful : false;
    },
  };
}

export { createSelector };
